import React, { useState } from "react";
import "../styles/AdminDashboard.css";
import { useNavigate } from "react-router-dom";
import Register from "../Components/Register.js";
import LeaveManagement from "../Components/LeaveManagement.js";
import CreateAccount from "../Components/CreateAccount.js";
import Message from "../Components/Message.js";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase.js";
import { useEffect } from "react";
import Message2 from "../Components/Message2.js";
import View from "../Components/View.js";
import Location from "../Components/Location.js";
import UserDashboard from "./UserDashboard.js";


const Sadmin = () => {
  const [activeTab, setActiveTab] = useState("register");
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/"); // Redirect to login page
  };

  const renderContent = () => {
  switch (activeTab) {
    case "register":
      return <Register />;
    case "leave":
      return <LeaveManagement />;
    case "account":
      return <CreateAccount />;
    case "location":
      return <Location />;
    default:
      return null;
  }
};

  const useLeaveNotifications = () => {
  const [newRequests, setNewRequests] = useState([]);

  useEffect(() => {
    const q = query(collection(db, "leaveRequests"), where("status", "==", "pending"));
    const unsub = onSnapshot(q, (snapshot) => {
      const requests = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setNewRequests(requests);
    });

    return () => unsub();
  }, []);

  return newRequests;
};

  return (
    <div className="admin-background">
  
    <div className="admin-dashboard">
     
      <header className="admin-header">
        {/* <h2>Super Admin Dashboard</h2> */}
        <nav className="admin-nav">

       <div className="yellow-grid">

          <button
            className={activeTab === "register" ? "active" : ""}
            onClick={() => setActiveTab("register")}
          >
            REGISTER
          </button>
          <button
            className={activeTab === "leave" ? "active" : ""}
            onClick={() => setActiveTab("leave")}
          >
            ROOM
          </button>
          <button
            className={activeTab === "account" ? "active" : ""}
            onClick={() => setActiveTab("account")}
          >
            ACCOUNT
          </button>
       
          <button
            className={activeTab === "location" ? "active" : ""}
            onClick={() => setActiveTab("location")}
          >
            LOCATION
          </button>

          </div>
        </nav>
      </header>

      <main className="admin-content">{renderContent()}</main>
    </div>
    </div>
  );
};

export default Sadmin;
